import { deserialize } from 'cerialize'
import { Id } from 'Types/aliases'

export class BlockModel {
	@deserialize public id: Id
	@deserialize public phone: string
	@deserialize public inn: string
	@deserialize public partner: any
	@deserialize public call_request_id: number
	@deserialize public effective_from: string
	@deserialize public effective_to: string
	@deserialize public active: boolean
	@deserialize public cause: string
	@deserialize public cause_translate: string
}
